/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/core';

import useImageLoader from 'hooks/useImageLoader';

const Background = ({ background, backgroundImageOpacity }) => {
  const imgLoadedState = useImageLoader(
    background ? background.split(/\(|\)/g)[1] : ''
  );

  const opacity = backgroundImageOpacity / 100;

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        // ...(background && { background }),
        ...(background && background.includes('url')
          ? {
              background,
              opacity: imgLoadedState === 2 ? 1 : 0,
              transition: 'opacity 1s',
            }
          : {
              background,
              transition: 'background 0.35s',
            }),
        opacity,
      }}
    />
  );
};

export default Background;
